export default __webpack_public_path__ + "static/media/navBg.df33c828.png";